/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, useMemo, useState } from 'react';
import { styled } from 'linaria/react';
import EasySwipe from 'react-easy-swipe';
import { Modal } from '@mtsbank/ui-kit';
import { SearchBankTextField } from '@features/bank/search-bank';
import { BankItem, LastUsedBankCard, useLastUsedBank, useSbpMembers } from '@entities/bank';
import { withTheme } from '@shared/lib';
import { useLockScroll, useBottomSheet } from '@shared/lib/react';
import { CrossIcon } from '@shared/assets/icons';
import { OldSpinner } from '@shared/ui/atoms';
import DataFetchingFailedError from './DataFetchingFailedError';
import NoResults from './NoResults';
interface ModalBannerProps {
  open: boolean;
  handleClose: () => void;
  qrLink: string;
  targetBank?: string;
}
const SbpQrModalMobile: FC<ModalBannerProps> = ({
  open,
  handleClose,
  qrLink,
  targetBank
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  useLockScroll(open);

  // @ts-ignore
  const {
    isClosing,
    onSwipeStart,
    onSwipeMove,
    onSwipeEnd,
    handleModalClose
  } = useBottomSheet({
    open,
    onClose: () => {
      setSearchTerm('');
      handleClose();
    },
    // @ts-ignore
    closeModalOnScrollUp: false
  });
  const {
    members,
    isMembersLoading,
    membersError
  } = useSbpMembers(qrLink);
  const lastUsedBank = useLastUsedBank({
    members
  });
  const filteredMembers = useMemo(() => members?.filter(member => member.name.toLowerCase().includes(searchTerm.toLowerCase().trim()) && targetBank ? member.name.toLowerCase().includes(targetBank.toLowerCase().trim()) : true), [members, searchTerm, targetBank]);
  const isLastUsedBankVisible = lastUsedBank && !searchTerm.trim() && !membersError && !targetBank;
  const isBankListVisible = !!filteredMembers?.length && !membersError;
  const isNoResultVisible = !filteredMembers?.length && !isMembersLoading && !membersError;
  return <StyledModal isClosing={isClosing} open={open} onClose={handleModalClose} closeIcon={<CrossIcon />} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Heading>Оплата через СБП</Heading>

          {!targetBank && <SearchBankTextFieldWrapper>
              <SearchBankTextField searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            </SearchBankTextFieldWrapper>}

          <ContentWrapper windowInnerHeight={window?.innerHeight}>
            {isLastUsedBankVisible && <LastUsedBankBlockWrapper>
                <Text>Вы ранее использовали</Text>
                <LastUsedBankCard lastUsedBank={lastUsedBank} />
              </LastUsedBankBlockWrapper>}
            {isBankListVisible && <BanksBlockWrapper>
                {!targetBank && <Text>Список банков</Text>}
                <BankListWrapper>
                  {filteredMembers?.map(item => <BankItem bank={item} />)}
                </BankListWrapper>
              </BanksBlockWrapper>}
            {isMembersLoading && <OldSpinner />}
            {membersError && <DataFetchingFailedError />}
            {isNoResultVisible && <NoResults />}
          </ContentWrapper>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
export default SbpQrModalMobile;
const SearchBankTextFieldWrapper = /*#__PURE__*/styled('div')({
  name: "SearchBankTextFieldWrapper",
  class: "s16sjzn",
  propsAsIs: false
});
interface StyledModalProps {
  isClosing: boolean;
  open: boolean;
}
const _exp = /*#__PURE__*/() => Modal;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "s1u9dvjh",
  propsAsIs: true,
  vars: {
    "s1u9dvjh-0": [_exp2()],
    "s1u9dvjh-1": [_exp3()],
    "s1u9dvjh-2": [_exp7(), "px"],
    "s1u9dvjh-3": [_exp5()],
    "s1u9dvjh-4": [_exp6(), "px"],
    "s1u9dvjh-5": [_exp8()],
    "s1u9dvjh-6": [_exp9()],
    "s1u9dvjh-7": [_exp0()]
  }
}));
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "h15n7hj7",
  propsAsIs: false,
  vars: {
    "h15n7hj7-0": [_exp1()],
    "h15n7hj7-1": [_exp10(), "px"],
    "h15n7hj7-2": [_exp11()],
    "h15n7hj7-3": [_exp12(), "px"],
    "h15n7hj7-4": [_exp13()]
  }
}));
const _exp14 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSText;
const _exp15 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp16 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp17 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp18 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "tbnhugu",
  propsAsIs: false,
  vars: {
    "tbnhugu-0": [_exp14()],
    "tbnhugu-1": [_exp15(), "px"],
    "tbnhugu-2": [_exp16()],
    "tbnhugu-3": [_exp17(), "px"],
    "tbnhugu-4": [_exp18()]
  }
}));
interface ContentWrapperProps {
  windowInnerHeight?: number;
}
const _exp19 = /*#__PURE__*/() => ({
  windowInnerHeight
}) => `calc(${windowInnerHeight ? `${windowInnerHeight}px` : '100vh'} - 235px)`;
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "ccfwopy",
  propsAsIs: false,
  vars: {
    "ccfwopy-0": [_exp19()]
  }
});
const BanksBlockWrapper = /*#__PURE__*/styled('div')({
  name: "BanksBlockWrapper",
  class: "btusbna",
  propsAsIs: false
});
const BankListWrapper = /*#__PURE__*/styled('div')({
  name: "BankListWrapper",
  class: "b1w3ji2y",
  propsAsIs: false
});
const LastUsedBankBlockWrapper = /*#__PURE__*/styled('div')({
  name: "LastUsedBankBlockWrapper",
  class: "ld6tghv",
  propsAsIs: false
});

require("./SbpQrModalMobile.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SbpQrModalMobile.tsx");